<main class="px-8 pt-6 pb-20">
  <ng-content></ng-content>
</main>
